<template>
  <div class="cardInfo">
    <template>
      <div class="d-flex-between-center p-t-16">
        <p class="f-16 f-Overpass f-bold remove-margin">{{ idTraining }}</p>
        <p :class="'f-12 f-Overpass f-c-midgrey remove-margin ' + status_css">
          {{ status_fix }}
        </p>
      </div>
    </template>

    <!-- nanti tambahkan kondisi && waktu bayar habis, ketika sudah ada data dari reza -->
    <template
      v-if="status == '60_menunggu_pembayaran' && timeStep != 'Waktu Habis'"
    >
      <div class="d-flex-between-center">
        <p class="f-12 f-Overpass f-c-midgrey remove-margin">
          Batas Waktu Pembayaran
        </p>

        <template v-if="timeStep != 'Waktu Habis'">
          <p class="f-14 f-c-red f-bold remove-margin">
            {{ timeStep }}
          </p>
        </template>
      </div>
    </template>

    <!-- pada free online pasti tidak ada pembayaran -->
    <!-- <template v-if="status == '10_menunggu_konfirmasi_cs'">
      <div class="d-flex-between-center m-t-2">
        <p></p>
        <p
          class="f-14 f-c-blue f-bold remove-margin"
          @click="cekInformasiBayar"
        >
          Informasi Pembayaran
        </p>
      </div>
    </template> -->

    <!-- nanti jadikan && , karena belum ada data yang pembayaran gagal -->
    <template
      v-if="status == '70_pembayaran_gagal' || timeStep == 'Waktu Habis'"
    >
      <div class="d-flex-between-center m-t-2">
        <p></p>
        <p class="f-14 f-c-red f-bold remove-margin">Waktu Bayar habis</p>
      </div>
    </template>

    <template
      v-if="
        status == '20_terjadwalkan' ||
        status == '30_dijadwalkan_ulang' ||
        status == '40_dibatalkan_oleh_cs' ||
        status == '10_menunggu_konfirmasi_cs'
      "
    >
      <div class="d-flex-between-center m-t-2">
        <p></p>
        <p class="f-14 f-c-blue f-bold remove-margin" @click="informasiTagihan">
          Informasi Tagihan
        </p>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "CardInfoDetail",
  props: {
    idTraining: "",
    status: "",
    batas_Waktu: "",
  },

  data() {
    return {
      timeStep: "",
      timeInterval: null,
    };
  },

  computed: {
    status_fix() {
      let text = this.status;
      let result = text.replace(/_/gi, " ");
      let parts = result.split(" ");
      let parts_slice = parts.slice(1);
      let capitalize = parts_slice.map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      });
      let join = capitalize.join(" ");
      return `${join}`;
    },

    status_css() {
      let text = this.status;
      let result = text.replace("_", "");
      let cls_css = result.replace(/^.{2}/g, "");
      return `${cls_css}`;
    },
  },

  methods: {
    countdown() {
      let timeEnd = new Date(this.batas_Waktu).getTime();
      let timeNow = new Date().getTime();
      let distance = timeEnd - timeNow;

      if (distance < 0) {
        clearInterval(this.timeInterval);
        this.timeStep = "Waktu Habis";
        return;
      }

      let minutes = String(
        Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      ).padStart(2, "0");
      let seconds = String(
        Math.floor((distance % (1000 * 60)) / 1000)
      ).padStart(2, "0");

      this.timeStep = minutes + ":" + seconds;
    },

    countdownStart() {
      this.timeInterval = setInterval(this.countdown, 1000);
      this.countdown();
    },

    informasiTagihan() {
      this.$router.push({
        name: "pendaftaran.success",
        params: { idjenis: this.idTraining },
      });
    },

    cekInformasiBayar() {
      this.$router.push({
        name: "detail.pembayaran",
        params: { idTraining: this.idTraining },
      });
    },
  },

  mounted() {
    this.countdownStart();
  },
};
</script>

<style scoped>
.link-tagihan {
  text-decoration: none;
}

.dibatalkan_oleh_cs {
  background-color: #da1e28;
  padding: 3px;
  width: fit-content;
  border-radius: 3px;
  color: #fff;
}
.dijadwalkan_ulang {
  background-color: #fff1f1;
  padding: 3px;
  width: fit-content;
  border-radius: 3px;
}
.terjadwalkan {
  background-color: #fceeff;
  padding: 3px;
  width: fit-content;
  border-radius: 3px;
}
.menunggu_konfirmasi_cs {
  background-color: #fff8e1;
  padding: 3px;
  width: fit-content;
  border-radius: 3px;
}
.menunggu_pembayaran {
  background-color: #e2f0ff;
  padding: 3px;
  width: fit-content;
  border-radius: 3px;
}

.selesai {
  background-color: #e2f0ff;
  padding: 3px;
  width: fit-content;
  border-radius: 3px;
}

.pembayaran_gagal {
  background-color: #fff1f1;
  padding: 3px;
  width: fit-content;
  border-radius: 3px;
}
</style>
